<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-top-choice`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.607 5.125a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-5.657 5.657-1.414 1.414a1 1 0 01-1.414 0L7.536 13.61l-2.829-2.828a1 1 0 010-1.414l1.414-1.415a1 1 0 011.415 0l2.121 2.122 4.95-4.95zM43 9a1 1 0 011 1v2a1 1 0 01-1 1H23a1 1 0 01-1-1v-2a1 1 0 011-1h20zM12 21.637a1 1 0 011 1v4a1 1 0 01-1 1H8a1 1 0 01-1-1v-4a1 1 0 011-1h4zm1 15a1 1 0 00-1-1H8a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4zM43 37a1 1 0 011 1v2a1 1 0 01-1 1H23a1 1 0 01-1-1v-2a1 1 0 011-1h20zm0-14a1 1 0 011 1v2a1 1 0 01-1 1H23a1 1 0 01-1-1v-2a1 1 0 011-1h20z"/></svg>
</template>
<script>

export default {
  name: 'IconTopChoice',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
